import { Application } from 'pixi.js'
import keyboard from '../lib/keyboard'

export const pause = (app: Application) => {
	const escKey = keyboard('Escape')
	let isPaused = false
	escKey.press = () => {
		if (isPaused) app.ticker.start()
		else app.ticker.stop()
		isPaused = !isPaused
		console.log('game is paused:', isPaused)
	}
}
